import { Link } from 'react-router-dom';
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';
import Contact from '../../home/components/Contact';
import WhatsAppDiagnostic from '../../home/components/WhatsAppDiagnostic';

export default function ChoisirFenetresLyon() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-indigo-600 via-purple-500 to-pink-500 pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl">
            <div className="inline-flex items-center space-x-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
              <i className="ri-lightbulb-line text-white"></i>
              <span className="text-white text-sm font-medium">Guide Complet 2025</span>
            </div>
            
            <h1 className="text-5xl lg:text-6xl font-extrabold text-white mb-6 leading-tight">
              Comment Choisir ses Fenêtres à Lyon
            </h1>
            
            <p className="text-xl text-white/90 mb-8 leading-relaxed">
              Guide complet pour bien choisir vos fenêtres à Lyon. Matériaux, vitrage, performances thermiques et budget : tous nos conseils d'experts pour faire le bon choix.
            </p>
            
            <div className="flex flex-wrap gap-4">
              <a
                href="#contact"
                className="inline-flex items-center justify-center bg-white text-indigo-600 px-8 py-4 rounded-full font-bold hover:bg-gray-50 transition-all shadow-lg whitespace-nowrap cursor-pointer"
              >
                Demander Conseil
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Article Content */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <article className="prose prose-lg max-w-none">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              Guide Complet : Choisir ses Fenêtres à Lyon en 2025
            </h2>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              Choisir de nouvelles fenêtres est un investissement important pour votre logement à Lyon. Entre les différents matériaux, types de vitrage et performances énergétiques, il n'est pas toujours facile de s'y retrouver. Ce guide vous aide à faire le meilleur choix selon vos besoins et votre budget.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              1. Choisir le Bon Matériau
            </h3>
            
            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              Fenêtres PVC : Le Meilleur Rapport Qualité-Prix
            </h4>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Le PVC est le matériau le plus populaire à Lyon pour plusieurs raisons : excellent rapport qualité-prix, isolation thermique et phonique optimale, entretien minimal, résistance aux intempéries et large choix de coloris. Prix moyen : 300€ à 800€ par fenêtre installée.
            </p>

            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              Fenêtres Aluminium : Design et Modernité
            </h4>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              L'aluminium séduit par son esthétique contemporaine et ses profilés fins permettant plus de luminosité. Idéal pour les grandes baies vitrées et les rénovations modernes. Durée de vie exceptionnelle de 40 à 50 ans. Prix moyen : 500€ à 1200€ par fenêtre.
            </p>

            <h4 className="text-xl font-bold text-gray-900 mb-3 mt-6">
              Fenêtres Bois : Charme et Authenticité
            </h4>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Le bois reste le choix privilégié pour les immeubles anciens du Vieux-Lyon et de la Presqu'île. Excellente isolation naturelle, charme authentique et possibilité de restauration. Nécessite un entretien régulier. Prix moyen : 400€ à 1000€ par fenêtre.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              2. Le Vitrage : Clé de l'Isolation
            </h3>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-indigo-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Double vitrage standard :</strong> Minimum obligatoire, coefficient Ug = 1.1 W/m².K</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-indigo-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Double vitrage renforcé :</strong> Avec gaz argon, Ug = 0.9 W/m².K, recommandé à Lyon</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-indigo-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Triple vitrage :</strong> Performance maximale, Ug = 0.6 W/m².K, pour maisons passives</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-indigo-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Vitrage phonique :</strong> Indispensable en centre-ville de Lyon (réduction jusqu'à 40 dB)</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              3. Les Performances à Vérifier
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Trois coefficients essentiels à vérifier lors de votre choix de fenêtres à Lyon :
            </p>

            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-arrow-right-s-line text-indigo-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Uw (isolation thermique) :</strong> Plus il est bas, meilleure est l'isolation. Visez &lt; 1.3 W/m².K</span>
              </li>
              <li className="flex items-start">
                <i className="ri-arrow-right-s-line text-indigo-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Sw (facteur solaire) :</strong> Entre 0.3 et 0.5 pour un bon équilibre à Lyon</span>
              </li>
              <li className="flex items-start">
                <i className="ri-arrow-right-s-line text-indigo-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>AEV (étanchéité) :</strong> Minimum A3 E6 V2 pour résister au climat lyonnais</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              4. Budget et Aides Financières
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Le budget pour changer vos fenêtres à Lyon varie selon plusieurs critères. Comptez en moyenne 400€ à 1000€ par fenêtre pose comprise. Plusieurs aides financières sont disponibles :
            </p>

            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-money-euro-circle-line text-indigo-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>MaPrimeRénov' :</strong> Jusqu'à 100€ par fenêtre selon vos revenus</span>
              </li>
              <li className="flex items-start">
                <i className="ri-money-euro-circle-line text-indigo-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Éco-PTZ :</strong> Prêt à taux zéro jusqu'à 15 000€</span>
              </li>
              <li className="flex items-start">
                <i className="ri-money-euro-circle-line text-indigo-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>TVA réduite :</strong> 5.5% au lieu de 20% pour la rénovation énergétique</span>
              </li>
              <li className="flex items-start">
                <i className="ri-money-euro-circle-line text-indigo-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Aides locales :</strong> Renseignez-vous auprès de la Métropole de Lyon</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              5. Critères Spécifiques à Lyon
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              À Lyon, certains critères sont particulièrement importants :
            </p>

            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-building-line text-indigo-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Immeubles classés :</strong> Dans le Vieux-Lyon, respectez les contraintes des Bâtiments de France</span>
              </li>
              <li className="flex items-start">
                <i className="ri-volume-up-line text-indigo-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Isolation phonique :</strong> Essentielle en centre-ville et près des axes routiers</span>
              </li>
              <li className="flex items-start">
                <i className="ri-shield-check-line text-indigo-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Sécurité :</strong> Privilégiez les fenêtres anti-effraction en rez-de-chaussée</span>
              </li>
              <li className="flex items-start">
                <i className="ri-sun-line text-indigo-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Orientation :</strong> Adaptez le vitrage selon l'exposition (sud = protection solaire)</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Conclusion : Nos Recommandations
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              Pour la plupart des logements à Lyon, nous recommandons des fenêtres PVC avec double vitrage renforcé (gaz argon) et isolation phonique. Ce choix offre le meilleur compromis entre performance, durabilité et budget. Pour les grandes baies vitrées, l'aluminium est idéal. Pour les immeubles anciens, privilégiez le bois ou des fenêtres mixtes bois-aluminium.
            </p>

            <p className="text-gray-700 leading-relaxed mb-6">
              N'hésitez pas à demander plusieurs devis et à vérifier les certifications (NF, Cekal, Acotherm). Un professionnel qualifié RGE vous garantira une pose dans les règles de l'art et l'accès aux aides financières.
            </p>
          </article>
        </div>
      </section>

      {/* WhatsApp Diagnostic */}
      <WhatsAppDiagnostic />

      {/* Contact */}
      <Contact />
      
      <Footer />
    </div>
  );
}
